<template>
  <div
    v-if="pageLoader"
    class="h-screen w-full flex items-center justify-center loader"
  >
    <LoadingComponent />
  </div>
  <header v-else class="bg-white text-black py-2">
    <div class="container mx-auto flex justify-between items-center h-20 px-8">
      <!-- Logo -->
      <div class="logo flex items-center space-x-2">
        <router-link to="/">
          <img src="../../assets/test-logo.png" alt="Logo" />
        </router-link>
        <!-- <span class="text-black text-xl font-bold">Buyer Compass</span> -->
      </div>

      <!-- Navigation Links -->
      <nav v-show="!mobile" class="flex items-center space-x-8 text-black">
        <router-link to="/" class="text-lg font-semibold">Home</router-link>
        <router-link to="/about" class="text-lg font-semibold"
          >About</router-link
        >
        <router-link to="/plans" class="text-lg font-semibold"
          >Plans & Pricing</router-link
        >
        <router-link to="/contact" class="text-lg font-semibold"
          >Contact</router-link
        >
        <el-dropdown
          trigger="click"
          :hide-on-click="true"
          ref="desktopDropdown"
        >
          <span class="el-dropdown-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              width="20"
              height="20"
              viewBox="0 0 512 512"
            >
              <g id="icomoon-ignore"></g>
              <path
                fill="#000"
                d="M242.774 0.996c-20.873 2.67-39.534 10.485-55.181 22.123l0.311-0.221c-7.651 5.689-19.94 18.546-25.6 26.823-12.277 17.708-19.613 39.652-19.613 63.309 0 1.663 0.036 3.319 0.108 4.965l-0.008-0.234c0.512 13.482 1.849 21.077 5.859 32.853 14.422 42.496 54.044 73.188 98.446 76.231 43.15 2.958 82.090-16.697 105.501-53.248 6.504-10.667 11.598-23.050 14.603-36.227l0.161-0.836c2.105-9.671 2.589-29.383 0.967-39.254-5.831-35.442-26.169-65.052-56.661-82.46-16.137-9.152-35.445-14.546-56.013-14.546-4.538 0-9.014 0.262-13.415 0.773l0.536-0.050zM271.36 58.937c15.161 4.21 27.79 14.564 35.356 28.956 4.267 8.135 5.888 15.161 5.945 25.6 0.086 10.809-1.11 16.042-5.717 25.6-4.95 10.24-15.075 20.394-25.344 25.458-7.449 3.857-16.26 6.12-25.6 6.12s-18.151-2.262-25.916-6.268l0.316 0.149c-13.568-6.684-25.629-21.276-29.469-35.698-1.215-4.412-1.915-9.478-1.915-14.708 0-25.78 16.978-47.594 40.363-54.872l0.407-0.109c8.818-2.617 22.585-2.73 31.573-0.227zM136.96 284.7c-69.66 3.641-124.644 53.163-135.339 121.913-0.671 5.678-1.054 12.255-1.054 18.921 0 0.248 0 0.496 0.001 0.743v-0.038c0.028 11.008 0.313 13.938 2.219 21.021 8.277 31.118 30.492 53.334 61.952 62.038l8.221 2.276h366.080l8.221-2.276c15.537-4.072 28.88-11.946 39.448-22.581l0.005-0.005c11.15-11.178 18.318-23.723 22.5-39.452 3.669-13.738 3.043-35.555-1.593-54.3-10.301-41.088-37.463-74.414-73.52-92.783l-0.805-0.373c-12.292-6.228-26.552-11.002-41.563-13.582l-0.905-0.128c-6.258-1.138-23.808-1.337-128-1.479-15.636-0.058-34.156-0.092-52.684-0.092-25.727 0-51.439 0.065-77.136 0.192l3.953-0.015zM384.114 342.585c32.604 5.832 58.507 29.399 67.628 60.178l0.154 0.608c1.678 5.632 2.332 10.183 2.674 18.176 0.398 9.529 0.256 11.178-1.394 15.531-3.178 7.176-8.774 12.8-15.733 15.935l-0.196 0.079c-4.665 1.735-5.319 1.735-181.248 1.735s-176.583 0-181.248-1.735c-7.154-3.214-12.751-8.838-15.85-15.817l-0.078-0.198c-1.65-4.352-1.792-6.002-1.394-15.531 0.91-21.646 9.671-40.789 25.657-56.093 13.085-12.515 27.050-19.712 44.345-22.87 9.643-1.735 246.698-1.735 256.683 0z"
              />
            </svg>
          </span>
          <template v-slot:dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-if="isAuthenticated"
                icon="el-icon-plus"
                @click="closeDropdown('desktop')"
              >
                <router-link to="/myWork" class="text-black font-semibold"
                  >My Work</router-link
                >
              </el-dropdown-item>
              <el-dropdown-item
                v-if="!isAuthenticated"
                icon="el-icon-plus"
                @click="closeDropdown('desktop')"
              >
                <router-link to="/login" class="text-black font-semibold"
                  >Login</router-link
                >
              </el-dropdown-item>
              <el-dropdown-item
                v-else
                icon="el-icon-plus"
                @click="closeDropdown('desktop')"
              >
                <a
                  href="#"
                  class="text-black font-semibold"
                  @click="handleLogout"
                  >Logout</a
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </nav>
      <div v-show="mobile" class="mobile-nav">
        <el-dropdown ref="mobileDropdown" trigger="click" :hide-on-click="true">
          <span class="el-dropdown-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35px"
              height="35px"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M4 6H20M4 12H20M4 18H20"
                stroke="#2f78a4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="closeDropdown('mobile')">
                <router-link to="/" class="">Home</router-link>
              </el-dropdown-item>
              <el-dropdown-item @click="closeDropdown('mobile')">
                <router-link to="/about" class="">About</router-link>
              </el-dropdown-item>
              <el-dropdown-item @click="closeDropdown('mobile')"
                ><router-link to="/plans" class=""
                  >Plans & Pricing</router-link
                ></el-dropdown-item
              >
              <el-dropdown-item @click="closeDropdown('mobile')"
                ><router-link to="/contact" class=""
                  >Contact</router-link
                ></el-dropdown-item
              >
              <el-dropdown-item
                v-if="isAuthenticated"
                @click="closeDropdown('mobile')"
                ><router-link to="/myWork" class=""
                  >My Work</router-link
                ></el-dropdown-item
              >
              <el-dropdown-item
                v-if="!isAuthenticated"
                @click="closeDropdown('mobile')"
              >
                <router-link to="/login" class="">Login</router-link>
              </el-dropdown-item>
              <el-dropdown-item v-else @click="closeDropdown('mobile')">
                <a href="#" class="text-red-500" @click="handleLogout"
                  >Logout</a
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
const mobileMQL = window.matchMedia("(max-width: 767px)");
const tabletMQL = window.matchMedia("(max-width: 1024px)");
export default {
  data() {
    return {
      dropdownOpen: false,
      pageLoader: false,
      mobile: false,
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
  },
  methods: {
    closeDropdown(type) {
      const dropdownRef =
        type === "desktop" ? "desktopDropdown" : "mobileDropdown";
      this.$refs[dropdownRef]?.handleClose();
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    ...mapActions(["logout"]),
    handleLogout() {
      this.pageLoader = true;

      this.logout()
        .then(() => {
          if (this.$route.path === "/") {
            window.location.reload();
          } else {
            this.$router.push("/");
          }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          this.pageLoader = false;
        });
    },
    handleResize() {
      this.mobile = mobileMQL.matches;
      if (mobileMQL.matches) {
        this.mobile = true;
      } else if (tabletMQL.matches) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
};
</script>
<style scoped>
.logo img {
  width: 370px;
  height: 80px;
}
@media (max-width: 767px) {
  .logo img {
    width: 160px;
    height: 50px;
  }
}
.el-dropdown-menu {
  min-width: 125px !important;
}

.router-link-active {
  color: var(--primary-color);
  font-weight: bold;
}

a:hover {
  color: var(--primary-color);
}

.mobile-nav {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-nav .el-dropdown-link {
  cursor: pointer;
}
</style>
